import api from 'app/actions/api';
import get from 'app/common/lib/get';

export const KIT_PRICE_EDIT_REQUEST = 'orgs/kits/KIT_PRICE_EDIT_REQUEST';
export const KIT_PRICE_EDIT_SUCCESS = 'orgs/kits/KIT_PRICE_EDIT_SUCCESS';
export const KIT_PRICE_EDIT_FAILURE = 'orgs/kits/KIT_PRICE_EDIT_FAILURE';
export const KIT_GROCERY_PRICE_EDIT = 'orgs/kits/KIT_GROCERY_PRICE_EDIT';

type KitPriceEditData = {
  title: string;
  fixed_price_enabled: boolean;
  fixed_price: string | number;
  building_id?: number;
  diet_food_type_id?: number;
  date: string; // "2025-30-12"  этот параметр не влияет на изменения, но нужен для получения актуальной информации в ответе
};

type KitPriceEditSuccessPayload = Record<string, unknown> | Array<unknown>;

type KitGroceryPriceEditPayload = {
  id: string | number;
  grocery_set_price: string | null;
};

type KitPriceEditFailurePayload = {
  err: string;
  error: unknown;
};

type KitPriceEditActionPayload =
  | KitPriceEditData
  | KitPriceEditSuccessPayload
  | KitGroceryPriceEditPayload
  | KitPriceEditFailurePayload;

export const kitPriceEditRequest = (payload?: KitPriceEditData) => ({
  type: KIT_PRICE_EDIT_REQUEST,
  payload,
});

export const kitPriceEditSuccess = (payload: KitPriceEditSuccessPayload) => ({
  type: KIT_PRICE_EDIT_SUCCESS,
  payload,
});

export const kitGroceryPriceEdit = (payload: KitGroceryPriceEditPayload) => ({
  type: KIT_GROCERY_PRICE_EDIT,
  payload,
});

export const kitPriceEditFailure = (payload: KitPriceEditFailurePayload) => ({
  type: KIT_PRICE_EDIT_FAILURE,
  payload,
});

export const kitPriceEdit = (orgId: string | number, kitId: string | number, data: KitPriceEditData) => async (
  dispatch: (action: { type: string; payload?: KitPriceEditActionPayload }) => void,
) => {
  dispatch(kitPriceEditRequest()); // ошибка, отсутствует аргумент
  try {
    const res = await api(`food/schools/${orgId}/complexes/${kitId}`, 'put', { data });
    const kitRes: KitPriceEditSuccessPayload = get(res, ['data', 'complexes'], []);
    dispatch(kitPriceEditSuccess(kitRes));
    return true
  } catch (error) {
    dispatch(kitPriceEditFailure({ err: 'Не удалось изменить цену комплекта', error }));
    return false;
  }
};
